import { isContentsCalculatorEnabled, isRebuildCalculatorEnabled } from 'ctm-components/components/feature_flags_utils';
import { homecontentsBrandcodes } from '../../constants';
import { getResultsScreenDisplayMode } from '../../../utils/displayMode';

export const footerDisclaimer = ({ fsgUrl, experimentId, coverType, hasGnafId, serverConfig }) => {
    // Detect current page from the browser's location
    const isCoverDetailsPage = typeof window !== 'undefined' && window.location.pathname === '/home-contents-insurance/journey/cover_details';
    const rebuildCalculatorDisclaimer = `<p>The rebuild estimate is provided by Finity Consulting Pty Limited (Finity)
            and should be used as a guide only and does not constitute personal advice. The estimate may not
            take into account all features of your property or your personal objectives, financial situation
            or needs. Please check with a valuer or other suitably qualified professional for an accurate
            estimate. Neither iSelect nor Finity accept any responsibility or liability for the accuracy of
            the estimate, or for any reliance on or use of the estimate as the basis of any decision.</p>`;
    const contentsCalculatorDisclaimer = `<p>Typical replacement costs are provided by Sum Insured. Whilst every care
            is taken to ensure the accuracy of the information as a guide for costing, no responsibility is
            accepted by Sum Insured for its accuracy. Please check with a valuer or other suitably qualified
            professional for an accurate estimate. iSelect takes no responsibility for the costs provided by
            Sum Insured nor any liability for the accuracy of or reliance upon or use of, the costs. Sum
            Insured is a trading name of Land Services SA Operating Pty Ltd (ACN 618 229 815) as trustee
            for Land Services SA Operating Trust (ABN 86 836 650 939). Figure rounded to nearest $100.</p>`;
    const homeContentsDisclaimer = `<p>Any quotes provided on the comparison results pages, are indicative and subject to change based on 
    further questions asked by the insurer.</p>
    <p>The website does not compare all home insurers or products in the market. 
    Any advice given is general advice only and does not take into account your objectives, financial situation or needs. 
    You should consider whether the advice is suitable for you and your personal circumstances, 
    and before you make any decision about whether to purchase a product, you should read the PDS for that product.</p>`;
    let additionalRebuildDisclaimerISLT = '';
    let additionalContentsDisclaimerISLT = '';
    if (isCoverDetailsPage && isRebuildCalculatorEnabled(serverConfig) && coverType !== 'C' && hasGnafId) {
        additionalRebuildDisclaimerISLT = rebuildCalculatorDisclaimer;
    }
    if (isCoverDetailsPage && isContentsCalculatorEnabled(serverConfig) && coverType !== 'H') {
        additionalContentsDisclaimerISLT = contentsCalculatorDisclaimer;
    }
    return `<p>The financial services provided in this comparison are provided by Compare the Market Pty Ltd ACN 117 323 378 AFSL 422926 (CTM) 
     acting as a representative of iSelect General Pty Limited ABN 90 131 798 126 AFSL 334115 (iSelect).</p>
    ${additionalRebuildDisclaimerISLT}
    ${additionalContentsDisclaimerISLT}
    ${homeContentsDisclaimer}
    <p>For more information about the range of insurers and products compared, how the service works (including management of conflicts of interest), 
    and how CTM and iSelect make  money (remembering that the service is free for you to use) read
     <a href="${fsgUrl}" target="_blank">Financial Services Guide (Car and Home Insurance Products)</a>. 
    A number of the home and contents insurance brands compared on the panel are arranged by Auto & General Services Pty Ltd ACN 003 617 909 
    on behalf of the insurer Auto & General Insurance Company Limited ACN 111 586 353, both of which are related entities of CTM and iSelect. 
    Our relationship with those companies does not impact the integrity of the comparison service, and we continue to work hard to encourage 
    brands that do not currently participate on our comparison service to come on board.</p>`;
};

export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: 'Trusted Partners',
        description: 'Trusted Partners, for the purpose of your invitation to call, are:',
        reasons: [
            'the insurer that ranks in position 1 on the results page;',
            'any other insurer with whom you express an interest to contact, by commencing an online application or enquiry.',
            'if we are unable to provide you with any quotes, a specialised broker - Shielded Insurance Brokers.'
        ]
    };
    return trustedPartnerConfig;
};

export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: '',
        description: ''
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    homecontentsBrandcodes.BUDD,
    homecontentsBrandcodes.WOOL,
    homecontentsBrandcodes.HUDD,
    homecontentsBrandcodes.EXCL,
    homecontentsBrandcodes.AHM
    // todo: Uncomment for BUPA go-live
    // homecontentsBrandcodes.BUPA
];

export const crossSellOtherVerticalsOnResults = () => false;
export const showNoResultsOverlayGenericMessage = () => false;
export const resultsScreenDefaultDisplayMode = (hasSavedResults, experimentId) => {
    return getResultsScreenDisplayMode(hasSavedResults, experimentId);
};

export const contactDetailOptInPrivacyMessage = ({ companyName, fsgUrl, privacyPolicyUrl }) => {
    return `I have read and accept the
    <a href="${privacyPolicyUrl}" target="_blank" data-id="websitePrivacyPolicyFormTermsLink" rel="noopener noreferrer">Privacy Collection Notice</a> and
    <a href="${fsgUrl}" target="_blank" data-id="websiteFinancialServicesGuideLink" rel="noopener noreferrer">Financial Services Guides (A & B)</a>,
    including that ${companyName} or its representatives may email and SMS me about the services it provides. By providing a contact number, I invite them or their
    <a id="trustedPartnersOpen" data-id="trustedPartnersOpen">Trusted Partners</a> to call me during the call centre
    <a id="callCentreHoursOpen" data-id="callCentreHoursOpen">opening hours</a> to discuss the potential purchase of a home and contents insurance policy.`;
};

export const enableResultsFeatureAccordion = () => true;
export const spinnerColour = () => '#FE5A19';
export const showPriceConfidenceBanner = () => false;
export const spinnerType = () => 'Default';
